<template>
    <div class="">
        <div v-if="prescriptions">
            <table class="table">
                <thead>
                <tr class="row m-0">
                    <th class="col-md-1">Recept</th>
                    <th class="col-md-5">Lék</th>
                    <th class="col-md-1">Diag.</th>
                    <th class="col-md-1">Hradí pacient</th>
                    <th class="col-md-1">Počet bal.</th>
                    <th class="col-md-1">Dávkování</th>
                    <th class="col-md-1">Notifikace</th>
                    <th class="col-md-1"></th>
                </tr>
                </thead>
                <tbody>
                    <template v-for="p in prescriptions">
                        <template v-for="(m, index) in p.medicaments" class="card-text">
                            <tr class="row m-0" :class="(p.status === 'ERROR' ? 'bg-danger-light' : '' )" :data-testid="index === 0 ? testIdPrefix + '-prescription-' + p.id : undefined">
                                <td class="text-left col-md-1" v-if="index === 0">
                                    <span v-if="p.type === 'printed'">papírový</span>
                                    <span v-if="p.type === 'electronic'" class="font-weight-bold">
                                        <i v-if="p.status === 'UNPREPARED'" class="fa fa-minus-circle text-warning" aria-hidden="true"></i>
                                        <i v-if="p.status === 'ERROR'" class="fa fa-exclamation-circle text-danger" aria-hidden="true" v-tooltip="{
                                            content: p.last_eprescription_message,
                                            classes: ['danger', 'half']}"></i>
                                        <i v-if="p.status === 'PREPARED'" class="fa fa-check-circle text-success" aria-hidden="true"></i>
                                        <span class="green">E</span>RECEPT
                                    </span>
                                </td>
                                <td v-else="" class="col-md-1 empty_cell"></td>
                                <td class="align-middle col-md-5">
                                    {{ m.medicine ? m.medicine.label : '' }}
                                    {{ m.individual_medicine ? m.individual_medicine.name : '' }}
                                </td>
                                <td class="align-middle col-md-1">
                                    {{ m.disease !== null ? m.disease.code : ''}}
                                </td>
                                <td class="align-middle col-md-1">
                                    {{ m.paid_by_sick | boolToCS }}
                                </td>
                                <td class="align-middle col-md-1">
                                    {{ m.amount }}
                                </td>
                                <td class="align-middle col-md-1">
                                    {{ m.dosage }}
                                </td>
                                <td class="align-middle col-md-1" v-if="index === 0">
                                    <span v-if="p.patient_notification_type === 'SMS'">SMS</span>
                                    <span v-else-if="p.patient_notification_type === 'EMAIL'">e-mail</span>
                                    <span v-else="" class="fa fa-minus" aria-hidden="true"></span>
                                </td>
                                <td class="text-left col-md-1" v-if="index === 0">
                                    <template v-if="p.status !== 'DELETED'">
                                        <template v-if="p.type === 'printed' || p.status === 'UNPREPARED'">
                                            <button class="btn btn-sm btn-danger btn_line-heigh-1" @click="removePrescription(p)"><i class="fa fa-trash" aria-hidden="true"></i></button>
                                        </template>
                                        <template v-if="toDeleteElectronicPrescriptionId === p.id">
                                            <input v-model="toDeleteElectronicPrescriptionReason" type="text" class="form-control form-control-sm" aria-describedby="reason" id="reason" placeholder="důvod zrušení eR.">
                                            <button class="btn btn-sm btn-danger btn_line-heigh-1" @click="removePrescription(p)"><i class="fa fa-trash" aria-hidden="true"></i></button>
                                        </template>
                                        <template v-else="">
                                            <template v-if="p.status === 'PREPARED'">
                                                <button class="btn btn-sm btn-danger btn_line-heigh-1" @click="setElectronicOPrescriptionToDelete(p.id)"><i class="fa fa-times" aria-hidden="true"></i></button>
                                            </template>

                                            <template v-if="p.type === 'printed' || p.status === 'PREPARED'">
                                                <a target="_blank" :href="hostname.hostname + 'prescription/printed/pdf?id=' + p.id" class="btn btn-sm btn-success btn_line-heigh-1"><i class="fa fa-print" aria-hidden="true"></i></a>
                                            </template>

                                        </template>
                                        <template v-if="p.status === 'ERROR'">
                                            <button class="btn btn-sm btn-primary btn_line-heigh-1" @click="sendToSuklElectronicPrescription(p.id)"><i class="fa fa-repeat" aria-hidden="true"></i></button>
                                        </template>
                                    </template>
                                    <template v-else="">
                                        <span class="text-danger font-weight-bold">SMAZÁNO</span>
                                    </template>
                                </td>
                                <td v-else="" class="col-md-1 empty_cell"></td>
                            </tr>
                        </template>
                    </template>
                    <template v-if="prescriptions.length > 0">
                        <tr class="row m-0">
                            <td class="col-md-5"></td>
                            <td class="text-left col-md-4 pt-2">
                                <button class="btn btn-sm btn-secondary" @click="updatePrescriptions()">aktualizuj seznam</button>
                                <template v-if="prescriptionsPrintedCount > 0">
                                  <a target="_blank" :href="hostname.hostname + 'prescription/printed/pdf?visit_id=' + visitId" class="btn btn-sm btn-success" v-if="visitId"><i class="fa fa-print" aria-hidden="true"></i> recepty ({{ prescriptionsPrintedCount }})</a>
                                  <a target="_blank" :href="hostname.hostname + 'prescription/printed/pdf?client_id=' + clientId + '&date=' + $moment().format('DD.MM.YYYY')" class="btn btn-sm btn-success" v-else><i class="fa fa-print" aria-hidden="true"></i> recepty ({{ prescriptionsPrintedCount }})</a>
                                </template>
                                <a target="_blank" class="btn btn-sm btn-success disabled" v-else=""><i class="fa fa-print" aria-hidden="true"></i> recepty (0)</a>

<!--                                <button class="btn btn-sm btn-secondary disabled btn_line-heigh-1" v-if="hasUnpreparedElectronicPrescription" @click="showEPrescriptionModal">Doplnit eRecepty</button>-->
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
        <div class="text-center" v-else-if="prescriptionsPending">
            <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i><br/>
            (načítám)
        </div>
        <div class="text-center" v-else="">
            (žádný recept nebyl vypsán)
        </div>
    </div>
</template>

<script>
  import apiMixin from '@/mixins'
  // import ElectronicPrescription from '@/views/Client/modals/ElectronicPrescription.vue'

  export default {
    data () {
      return {
        hostname: require('@/variables.js'),
        // Prescriptions
        prescriptions: false,
        prescriptionsPending: false,
        prescriptionsError: false,
        // single medicaments,
        selectedSeparatedIds: [],
        selectedEPrescriptionIds: [],
        allMedicamentIds: [],
        // post prescriptions
        hasUnpreparedElectronicPrescription: false,
        // delete prescription
        toDeleteElectronicPrescriptionReason: '',
        toDeleteElectronicPrescriptionId: null,
        sendToSuklElectronicPrescriptionDone: false,
        // delete electronic prescription
        deleteElectronicPrescriptionPending: false,
        deleteElectronicPrescriptionError: false,
        deleteElectronicPrescriptionDone: false
      }
    },
    props: ['doUpdate', 'clientId', 'visitId'],
    mixins: [apiMixin],
    computed: {
      testIdPrefix () {
        return this.visitId ? 'visit' : 'client'
      },
      prescriptionsPrintedCount () {
        let count = 0
        for (let index = 0; index < this.prescriptions.length; index++) {
          if (this.prescriptions[index].type === 'printed' || (this.prescriptions[index].type === 'electronic' && this.prescriptions[index].status === 'PREPARED')) {
            count++
          }
        }

        return count
      },
      prescriptionsElectronicCount () {
        this.hasUnpreparedElectronicPrescription = false
        let count = 0
        for (let index = 0; index < this.prescriptions.length; index++) {
          if (this.prescriptions[index].type === 'electronic') {
            if (this.prescriptions[index].status === 'PREPARED') {
              count++
            }
            if (this.prescriptions[index].status === 'UNPREPARED') {
              this.hasUnpreparedElectronicPrescription = true
            }
          }
        }

        return count
      }
    },
    methods: {
      // showModal (name) {
      //   this.$modal.show(name)
      // },
      // showEPrescriptionModal () {
      //   this.modalEPrescriptionOpened = true
      //   this.showModal('electronic-prescription')
      // },
      removePrescription (ep) {
        if (ep.type === 'printed') {
          //
        } else {
          ep.reason = this.toDeleteElectronicPrescriptionReason
          this.deleteElectronicPrescription(ep)
        }
      },
      setElectronicOPrescriptionToDelete (id) {
        this.toDeleteElectronicPrescriptionId = id
      },
      updatePrescriptions () {
        if (this.visitId) {
          this.getPrescriptions(this.visitId)
        } else {
          this.getClientPrescriptions(this.clientId, this.$moment().format('DD.MM.YYYY'))
        }
        this.$emit('updated')
      }
    },
    watch: {
      doUpdate (val) {
        if (val === true) {
          this.updatePrescriptions()
        }
      },
      visitId () {
        this.updatePrescriptions()
      },
      clientId () {
        this.updatePrescriptions()
      },
      deleteElectronicPrescriptionDone (val) {
        if (val === true) {
          this.updatePrescriptions()
          this.deleteElectronicPrescriptionDone = false
        }
      },
      sendToSuklElectronicPrescriptionDone (val) {
        if (val === true) {
          this.updatePrescriptions()
          this.sendToSuklElectronicPrescriptionDone = false
        }
      }
    },
    beforeMount () {
      this.updatePrescriptions()
    }
    // components: {
    //   ElectronicPrescription
    // }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .table th, .table td {
        padding: 1px;
    }

    .no-top-border {
        border-top: none;
    }

    .btn_line-heigh-1 {
        line-height: 1;
    }

    td.empty_cell {
        border-top: none !important;
    }

    span.green {
        color: green;
    }

</style>



// WEBPACK FOOTER //
// src/views/Prescribtion/ListPrescription.vue?32e6f511